import styled, { css } from 'styled-components';
import Box from '../../../../../_shared/components/Box';
import Icon from '../../../../../_shared/components/Icon';
import { footerVariants } from '../../Footer/Styles';
import { NetworkVariant } from '../../../../../_shared/types/trade';

export const StyledDealerInfo = styled(Box)`
  flex: 1 1 auto;
  align-items: center;
  height: 100%;
`;

export const Dealership = styled.div`
  display: flex;
  align-items: center;

  ${props => footerVariants[props.variant]};
`;

export const DealerBadges = styled.div``;

export const StyledStar = styled(Icon).attrs(() => ({
  icon: 'TR5-Icon-Star-Filled'
}))`
  height: 12px;
  width: 12px;
  margin-left: 3px;
`;

const condensed = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 140px;
`;
export const DealerName = styled.div`
  ${props => props.shouldCondense && condensed}
  margin-right: 6px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledDealerRating = styled(Box)`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  align-items: center;
`;

export const DealerNetwork = styled.div`
  display: flex;
  align-items: center;
  max-height: 36px;
`;

export const DealerRatingCount = styled.div`
  margin: 2px 0 0 3px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_35};
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
`;

export const Divider = styled.span`
  margin: 0 5px;
`;

export const IconContainer = styled.div`
  max-width: 18px;
  margin-right: 10px;
  svg {
    height: 18px;
    width: 18px;
  }
`;

export const networkVariants = {
  [NetworkVariant.ACTIVE]: css`
    max-width: 175px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `,
  [NetworkVariant.PENDING]: css`
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  `
};

export const NetworkName = styled.p`
  ${props => networkVariants[props.variant]};
  position: relative;
`;
